import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/remote-config'
import firebase from 'firebase/app'
import { log, warn } from '@coldandgoji/utilities'

let Authentication = null
let Configuration = null
let Database = null
let Datastore = null

// Firebase Configuration
const initialize = configuration => {
  log( '@coldandgoji/svelte-firebase', 'initialize' )

  // General
  if ( !configuration.FIREBASE_API_KEY ) {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_API_KEY is not configured. Firebase will not be initialized.' )
    return true
  }
  if ( !configuration.FIREBASE_APP_ID ) {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_APP_ID is not configured. Firebase will not be initialized.' )
    return true
  }
  if ( !configuration.FIREBASE_PROJECT_ID ) {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_PROJECT_ID is not configured. Firebase will not be initialized.' )
    return true
  }

  const options = {}
  if ( configuration.FIREBASE_API_KEY ) options.apiKey = configuration.FIREBASE_API_KEY
  if ( configuration.FIREBASE_APP_ID ) options.appId = configuration.FIREBASE_APP_ID
  if ( configuration.FIREBASE_PROJECT_ID ) options.projectId = configuration.FIREBASE_PROJECT_ID
  
  // Authentication
  if ( configuration.FIREBASE_AUTH_DOMAIN ) {
    options.authDomain = configuration.FIREBASE_AUTH_DOMAIN
  } else {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_AUTH_DOMAIN is not configured. Authentication will not be available.' )
  }

  // Firebase
  if ( configuration.FIREBASE_DATABASE_URL ) {
    options.databaseURL = configuration.FIREBASE_DATABASE_URL
  } else {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_DATABASE_URL is not configured. RTDB will not be available.' )
  }

  // Analytics
  if ( configuration.FIREBASE_MEASUREMENT_ID ) {
    options.measurementID = configuration.FIREBASE_MEASUREMENT_ID
  } else {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_MEASUREMENT_ID is not configured. Analytics will not be available.' )
  }

  // Storage
  if ( configuration.FIREBASE_STORAGE_BUCKET ) {
    options.storageBucket = configuration.FIREBASE_STORAGE_BUCKET
  } else {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_STORAGE_BUCKET is not configured. Storage will not be available.' )
  }

  // Messaging
  if ( configuration.FIREBASE_MESSAGING_SENDER_ID ) {
    options.messagingSenderId = configuration.FIREBASE_MESSAGING_SENDER_ID
  } else {
    warn( '@coldandgoji/svelte-firebase', 'FIREBASE_MESSAGING_SENDER_ID is not configured. Messaging will not be available.' )
  }

  // Initialize Firebase connection
  firebase.initializeApp( options )

  // Initialize Analytics
  if ( options.measurementId ) {
    firebase.analytics()
  }

  // Initialize Authentication
  if ( options.authDomain ) {
    Authentication = firebase.auth()
  }

  // Initialize RTDB (root)
  if ( options.databaseURL ) {
    Database = {
      ROOT: firebase.app().database( configuration.FIREBASE_DATABASE_URL ),
    }

    // Initialize RTDB (shards)
    if ( configuration.FIREBASE_DATABASES ) {
      configuration.FIREBASE_DATABASES.split( ',' ).forEach( database => {
        Database[ database.toUpperCase() ] = firebase.app().database( `https://${ configuration.FIREBASE_PROJECT_ID }-${ database }.firebaseio.com` )
      } )
    }
  }

  // Initialize Firestore
  if ( configuration.FIREBASE_DATASTORES ) {
    Datastore = {
      ROOT: firebase.firestore()
    }

    if ( configuration.FIREBASE_DATASTORES ) {
      configuration.FIREBASE_DATASTORES.split( ',' ).forEach( connection => {
        const parts = connection.split( ':' )
        if ( parts.length > 1 ) {
          Datastore[ parts[ 0 ].toUpperCase() ] = firebase.firestore().collection( parts[ 1 ] )
        } else {
          Datastore[ parts[ 0 ].toUpperCase() ] = firebase.firestore().collection( parts[ 0 ] )
        }
      } )
    }
  }

  if ( configuration.FIREBASE_REMOTE_CONFIG ) {
    Configuration = firebase.remoteConfig()
    Configuration.settings = {
      minimumFetchIntervalMillis: 60000,
    }
  }
}

export {
  Authentication,
  Configuration,
  Database,
  Datastore,
  initialize,
}
